export default "__VITE_ASSET__O3AayVAy__"